import { render, staticRenderFns } from "./LayoutTabs.vue?vue&type=template&id=55883480&scoped=true&"
var script = {}
import style0 from "./LayoutTabs.vue?vue&type=style&index=0&id=55883480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55883480",
  null
  
)

export default component.exports